<template>
  <div
    role="button"
    tabindex="0"
    class="badge-group"
    :aria-label="badgeText"
    @click="toggleBadge"
    @keypress.enter="toggleBadge"
  >
    <div aria-hidden="true" :class="badgeClass">
      <i class="material-icons-outlined">{{ icon }}</i>
    </div>
    <outside-click v-if="badgeOpen" @outside-click-action="toggleBadge">
      <div class="badge-info -open">
        <div aria-hidden="true" class="badge-info-close">
          <i class="material-icons-outlined">close</i>
        </div>
        <div class="badge-info-text">
          {{ badgeText }}
        </div>
      </div>
    </outside-click>
  </div>
</template>

<script>
// @flow
import OutsideClick from '@/components/tool-tips/outside-click.vue'

export default {
  name: 'CommentBadge',
  components: { OutsideClick },
  props: {
    icon: {
      type: String,
      required: true,
    },
    badgeClass: {
      type: String,
      default: 'badge verified',
    },
    badgeText: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      badgeOpen: false,
    }
  },

  methods: {
    toggleBadge() {
      console.log('toggleBadge hit')
      this.badgeOpen = !this.badgeOpen
    },
  },
}
</script>
